// removed by extract-text-webpack-plugin
module.exports = {"container":"_38Ah-m16NBKBQnBnis_AuO"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/accomplishments/accomplishments.css
// module id = 98
// module chunks = 0